export const ScheduleCommentaryStatus = Object.freeze({
    SENT: "sent",
    APPROVED: "approved",
    PUBLISHED: "published",
})
